import { Component } from "react";
import { useTranslation } from "react-i18next";

// Functional component that uses the `useTranslation` hook
const ComponentWithTranslation = ({ name, fallbackMessage }) => {
    const { t } = useTranslation();
    const componentLevelMsg = t("An error occurred while rendering the {{name}}. Please try again later.", {
        name
    });

    return <div>{name ? componentLevelMsg : fallbackMessage}</div>;
};
class ErrorBoundary extends Component {
    constructor (props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError () {
        // Update state to show fallback UI
        return { hasError: true };
    }

    componentDidCatch (error, errorInfo) {
        // Log the error to an error reporting service
        console.error("Error caught in ErrorBoundary:", error, errorInfo);
    }

    render () {
        const { hasError } = this.state;
        const { children, fallbackMessage = "Something went wrong. Please try again later.", name = "" } = this.props;

        if (hasError) {
            // Fallback UI when an error occurs
            return <ComponentWithTranslation children={children} name={name} fallbackMessage={fallbackMessage} />;
        }

        return children;
    }
}

export default ErrorBoundary;
